<template>
    <div class="basket">
        <div class="basket-header">
            <h2>{{ $t('components.Basket.1') }}</h2>
            <Button :listener="() => {this.$store.dispatch('act_SHOW_BASKET')}" text="&#10006;"/>
        </div>
        <div v-if="Object.keys(this.$store.state.inBasket).length > 0" class="basket-products">
            <div class="grb">
                <div :key="item.id" v-for="item in this.$store.state.inBasket" class="single">
                <div class="single-img">
                    <img :src="require(`../assets/products/${item[0].img}`)" alt='cat'>
                </div>
                <div class='single-data'>
                    <p class="single-data-name">{{item[0].name}} </p>
                    <p class="single-data-price"><span style="font-weight:600">{{item[0].price}}</span> {{item[0].t}} </p>
                    <p class="single-data-id"> ID: {{item[0].id}}</p>
                    <div class='single-data-actions'>
                        <Button :listener="() => this.RemoveFromBasket(item[0].id)" :text="$t('components.Basket.2')"/>
                    </div>
                </div>
                </div>
            </div>
            <div class="single total">
                <div class="column">
                    <div class="r-cont">
                        <input id="wid" type="radio" value="widget" v-model="type">
                        <label for="wid">{{ $t('components.Basket.3') }}</label>
                    </div>
                    <div class="r-cont">
                        <input id="mer" type="radio" value="merchant" v-model="type">
                        <label for="mer">{{ $t('components.Basket.4') }}</label>
                    </div>
                </div>
                
                    <Button :listener="() => {this.devForm = !this.devForm}" :text="$t('components.Basket.5')" class="big"></Button>
                    <div class="devForm" v-if="this.devForm">
                        <div><label>ext_transact</label><input type="text" v-model="this.devData.ext_transact"></div>
                        <div><label>num_shop</label><input type="text" v-model="this.devData.num_shop"></div>
                        <div><label>keyt_shop</label><input type="text" v-model="this.devData.keyt_shop"></div>
                        <div><label>payform</label><input type="text" v-model="this.devData.payform"></div>
                        <div><label>comment</label><input type="text" v-model="this.devData.comment"></div>
                        <div><label>url_success</label><input type="text" v-model="this.devData.url_success"></div>
                        <div><label>url_decline</label><input type="text" v-model="this.devData.url_decline"></div>
                        <div><label>url_callback</label><input type="text" v-model="this.devData.url_callback"></div>
                        <div><label>proc_url</label><input type="text" v-model="this.devData.proc_url"></div>
                        <div><label>shop_key</label><input type="text" v-model="this.devData.shop_key"></div>
                        <Button :listener="() => {this.updDevData()}" :text="$t('components.Basket.6')"></Button>
                    </div>
                
                <div class='single-data flex-s'>
                    <p>{{ $t('components.Basket.7') }}: <span style="font-weight:600">{{this.total}}</span> {{ this.$store.state.sendData.curr }}</p>
                    <Button :listener="this.send" :disabled="this.type ? false : true" :text="$t('components.Basket.8')" class='big'/>
                </div>
            </div>
        </div>
        <div v-else class="basket-products">
            <div class='single'>
                <h2>{{ $t('components.Basket.9') }}</h2>
            </div>
        </div>
    </div>
</template>

<script>
import Button from '@/components/Button.vue'
import {openWidget} from '@/widget/widget.class.js';

export default {
    components: {
        Button
    },
    data() {
        return {
            type: false,
            devForm: false,
            devData: {
                ext_transact: this.$store.state.sendData.merchant_params.ext_transact,
                num_shop: this.$store.state.sendData.merchant_params.num_shop,
                keyt_shop: this.$store.state.sendData.merchant_params.keyt_shop,
                payform: this.$store.state.sendData.merchant_params.payform,
                comment: this.$store.state.sendData.merchant_params.comment,
                url_success: this.$store.state.sendData.merchant_params.url_success,
                url_decline: this.$store.state.sendData.merchant_params.url_decline,
                url_callback: this.$store.state.sendData.merchant_params.url_callback,
                proc_url: this.$store.state.sendData.merchant_params.proc_url,
                shop_key: this.$store.state.sendData.shop_key,
                method: 'POST'
            }
        }
    },
    computed: {
        total() {
            return this.$store.getters.get_TOTAL_SUMM;
        }
    },
    methods: {
        RemoveFromBasket(id) {
            this.$store.commit('REMOVE_FROM_BASKET', id);
        },
        updDevData() {
            this.$store.commit('SEND_DATA', this.devData);
        },
        send() {
            if (this.type == 'widget') {
                this.sendToFrameTest();
            } else if (this.type == 'merchant') {
                this.sendToMerchant();
            }
        },
        sendToMerchant() {
            let context = this.$store;
            console.log(this.$store.state)
            let pay_params = this.$store.state.sendData.merchant_params;
            pay_params['sum'] = this.total;
            pay_params['free_param'] = Object.keys(this.$store.state.inBasket).join('/');
            pay_params['shop_key'] = this.$store.state.sendData.shop_key;
            console.log('pay_params', pay_params)
            // console.log(pay_params)
            this.axios.post('sign.php', pay_params).then(res => {
                if (res.data.sign) {
                    pay_params['sign'] = res.data.sign;
                    // console.log(pay_params)
                    delete pay_params['shop_key'];
                    var url = new URL(pay_params.proc_url);
                        for(let p in pay_params) {
                            url.searchParams.append(p, pay_params[p]);
                        }
                        // console.log(url)
                        window.location.href = url;
                    }
            });
        },
        sendToFrameTest() {
            let context = this.$store;
            let pay_params = this.$store.state.sendData.merchant_params;
            pay_params['sum'] = this.total;
            pay_params['free_param'] = Object.keys(this.$store.state.inBasket).join('/');
            pay_params['shop_key'] = this.$store.state.sendData.shop_key;
            console.log('pay_params', pay_params)
            this.axios.post('sign.php', pay_params).then(res => {
                if (res.data.sign) {
                    pay_params['sign'] = res.data.sign;
                    delete pay_params['shop_key'];
                    let params = {
                        frame_id: 'test_frame',
                        frame_name: 'to_pay',
                        pay_params: pay_params,
                        onSuccess: function (result) {
                            result['result_code'] = result.success == '1' ? '0' : '1';
                            context.commit('PAY_RESULT', {res:result});
                        },
                        onFail: function (result) {
                            result['result_code'] = result.success == '1' ? '0' : '1';
                            context.commit('PAY_RESULT', {res:result});
                    }};
                    openWidget(params);
                    this.$store.commit('SHOW_BASKET');
                    // var url = new URL(pay_params.proc_url);
                    //     for(let p in pay_params) {
                    //         url.searchParams.append(p, pay_params[p]);
                    //     }

                    //     window.location.href = url;
                    }
            });
        }
    },
}
</script>

<style lang="scss">
.devForm {
    width: 100%;

    label {
        width: 30%;
        margin-right: 10px;
    }
    input {
        width: 100%;
    }
}
</style>